import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { PriceListModel } from 'src/app/models/archive/price-list.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PriceListService {

  constructor(private _httpClient: HttpClient) { }

  createPriceList(priceListContract: PriceListModel): Observable<PriceListModel> {
    return this._httpClient.post<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.CreatePriceList}`,
      priceListContract);
  }

  deletePriceList(priceListId: number): Observable<PriceListModel> {
    return this._httpClient.delete<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.DeletePriceList}/${priceListId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllPriceListsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetAllPriceListsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstPriceListByKeysAsync(branchId: number): Observable<PriceListModel> {
    return this._httpClient.get<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetFirstPriceListByKeysAsync}/${branchId}`);
  }

  getLastPriceListByKeysAsync(branchId: number): Observable<PriceListModel> {
    return this._httpClient.get<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetLastPriceListByKeysAsync}/${branchId}`);
  }

  getNextPriceListByKeysAsync(branchId: number, code: number): Observable<PriceListModel> {
    return this._httpClient.get<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetNextPriceListByKeysAsync}/${branchId}/${code}`);
  }

  getPreviusPriceListByKeysAsync(branchId: number, code: number): Observable<PriceListModel> {
    return this._httpClient.get<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetPreviusPriceListByKeysAsync}/${branchId}/${code}`);
  }

  getPriceListByBranchId(branchId: number): Observable<Array<PriceListModel>> {
    return this._httpClient.get<Array<PriceListModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetPriceListByBranchId}/${branchId}`)
  }

  getPriceListByCodeAsync(branchId: number, code: number): Observable<PriceListModel> {
    return this._httpClient.get<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetPriceListByCodeAsync}/${branchId}/${code}`);
  }

  getPriceListById(priceListId: number): Observable<PriceListModel> {
    return this._httpClient.get<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.GetPriceListById}/${priceListId}`);
  }

  updatePriceList(priceListContract: PriceListModel): Observable<PriceListModel> {
    return this._httpClient.put<PriceListModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.priceList.UpdatePriceList}`,
      priceListContract);
  }
}
